import { makeStyles, withStyles } from "@material-ui/core"
import ArchiveIcon from "@mui/icons-material/Archive"
import StarIcon from "@mui/icons-material/Star"
import VisibilityIcon from "@mui/icons-material/Visibility"
import Typography from "@mui/material/Typography"
import { Box } from "@mui/system"
import React, { useEffect, useState } from "react"
import { grayColor } from "../../../style/style"
import WidgetCommon from "../Common/widgetCommon"

const styles = () => ({})
const useStyles = makeStyles({
  iconContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
  },
  iconItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  number: {
    marginTop: 5,
  },
  icon: {
    color: "#6A6A6A",
  },
})

const InsightStatuses = (props) => {
  const {
    isLoading,
    insights,
    allowEdits,
    handleWidgetChange,
    widgetId,
    gridStep,
    position,
    size,
    handleRemove,
  } = props
  const [acknowledged, setAcknowledged] = useState(null)
  const [favorited, setFavorited] = useState(null)
  const [archived, setArchived] = useState(null)

  const classes = useStyles()

  useEffect(() => {
    if (insights) {
      setAcknowledged(
        insights.filter((insight) => insight.insight.insight_status === "acknowledge").length,
      )
      setFavorited(
        insights.filter((insight) => insight.insight.insight_status === "favorite").length,
      )
      setArchived(insights.filter((insight) => insight.insight.insight_status === "archive").length)
    }
  }, [insights])

  return (
    <WidgetCommon
      widgetId={widgetId}
      title="Status"
      isLoading={isLoading}
      hasNoData={!insights}
      size={size}
      position={position}
      allowResize={true}
      allowEdits={allowEdits}
      handleWidgetChange={handleWidgetChange}
      gridStep={gridStep}
      handleRemove={handleRemove}
    >
      <Box className={classes.iconContainer}>
        <Box className={classes.iconItem}>
          <VisibilityIcon className={classes.icon} style={{ fontSize: 55 }} />
          <Typography variant="h4" style={{ color: grayColor[2] }}>
            {acknowledged}
          </Typography>
        </Box>
        <Box className={classes.iconItem}>
          <ArchiveIcon className={classes.icon} style={{ fontSize: 55 }} />
          <Typography variant="h4" style={{ color: grayColor[2] }}>
            {archived}
          </Typography>
        </Box>
        <Box className={classes.iconItem}>
          <StarIcon className={classes.icon} style={{ fontSize: 55 }} />
          <Typography variant="h4" style={{ color: grayColor[2] }}>
            {favorited}
          </Typography>
        </Box>
      </Box>
    </WidgetCommon>
  )
}

export default withStyles(styles)(InsightStatuses)
